var Handlebars = require("/home/travis/build/thelounge/lounge/node_modules/handlebars/runtime.js");
function __default(obj) { return obj && (obj.__esModule ? obj["default"] : obj); }
module.exports = (Handlebars["default"] || Handlebars).template({"1":function(container,depth0,helpers,partials,data) {
    var stack1, alias1=depth0 != null ? depth0 : (container.nullContext || {});

  return "			<tr>\n				<td class=\"channel\">"
    + ((stack1 = __default(require("/home/travis/build/thelounge/lounge/client/js/libs/handlebars/parse.js")).call(alias1,(depth0 != null ? depth0.channel : depth0),{"name":"parse","hash":{},"data":data})) != null ? stack1 : "")
    + "</td>\n				<td class=\"users\">"
    + container.escapeExpression(container.lambda((depth0 != null ? depth0.num_users : depth0), depth0))
    + "</td>\n				<td class=\"topic\">"
    + ((stack1 = __default(require("/home/travis/build/thelounge/lounge/client/js/libs/handlebars/parse.js")).call(alias1,(depth0 != null ? depth0.topic : depth0),{"name":"parse","hash":{},"data":data})) != null ? stack1 : "")
    + "</td>\n			</tr>\n";
},"compiler":[7,">= 4.0.0"],"main":function(container,depth0,helpers,partials,data) {
    var stack1;

  return "<table class=\"channel-list\">\n	<thead>\n		<tr>\n			<th class=\"channel\">Channel</th>\n			<th class=\"users\">Users</th>\n			<th class=\"topic\">Topic</th>\n		</tr>\n	</thead>\n	<tbody>\n"
    + ((stack1 = helpers.each.call(depth0 != null ? depth0 : (container.nullContext || {}),(depth0 != null ? depth0.channels : depth0),{"name":"each","hash":{},"fn":container.program(1, data, 0),"inverse":container.noop,"data":data})) != null ? stack1 : "")
    + "	</tbody>\n</table>\n";
},"useData":true});


//////////////////
// WEBPACK FOOTER
// ./client/views/actions/channel_list.tpl
// module id = 218
// module chunks = 0